<template>
    <div>
        <rkm-area
            v-if="!hideCidadaos && cidadaos.length > 0"
            type="section"
            title="Cidadão"
        >
            <rkm-table
                :items="cidadaos"
                :fields="fields.cidadao"
                tag="div"
                hide-filters
            >
                <template v-slot:cell(actions)='{ item }'>
                    <rkm-button
                        color="primary"
                        title="Continuar com este cadastro."
                        small
                        @click.stop="$emit('select-cidadao', item)"
                    >
                        <rkm-icon icon="check" />
                    </rkm-button>
                </template>

                <template v-slot:cell(dataNascimento)='row'>
                    {{ row.value | formatDate }}
                </template>

                <template v-slot:cell(telefonePrincipal.numero)='row'>
                    {{ row.value | formatPhoneOrCellPhone }}
                </template>

                <template v-slot:cell(cpfNaoPertenceAoCidadao)='row'>
                    {{ row.value ? 'Não' : 'Sim' }}
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            v-if="showUsuarios && usuarios.length > 0"
            type="section"
            title="Usuário"
        >
            <rkm-table
                :items="usuarios"
                :fields="fields.usuario"
                tag="div"
                hide-filters
            >
                <template v-slot:cell(cidadao.actions)='{ item }'>
                    <rkm-button
                        color="primary"
                        title="Selecionar usuário."
                        small
                        @click.stop="$emit('select-usuario', item)"
                    >
                        <rkm-icon icon="check" />
                    </rkm-button>
                </template>

                <template v-slot:cell(cidadao.dataNascimento)='row'>
                    {{ row.value | formatDate }}
                </template>

                <template v-slot:cell(cidadao.telefonePrincipal.numero)='row'>
                    {{ row.value | formatPhoneOrCellPhone }}
                </template>

                <template v-slot:cell(cidadao.cpfNaoPertenceAoCidadao)='row'>
                    {{ row.value ? 'Não' : 'Sim' }}
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            v-if="showPacientes && pacientes.length > 0"
            type="section"
            title="Paciente"
        >
            <rkm-table
                :items="pacientes"
                :fields="fields.paciente"
                tag="div"
                hide-filters
            >
                <template v-slot:cell(cidadao.actions)='{ item }'>
                    <rkm-button
                        color="primary"
                        title="Selecionar paciente."
                        small
                        @click.stop="$emit('select-paciente', item)"
                    >
                        <rkm-icon icon="check" />
                    </rkm-button>
                </template>

                <template v-slot:cell(cidadao.dataNascimento)='row'>
                    {{ row.value | formatDate }}
                </template>

                <template v-slot:cell(cidadao.telefonePrincipal.numero)='row'>
                    {{ row.value | formatPhoneOrCellPhone }}
                </template>

                <template v-slot:cell(cidadao.cpfNaoPertenceAoCidadao)='row'>
                    {{ row.value ? 'Não' : 'Sim' }}
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Filters
import formats from '@/filters/formats'

export default {
    computed: {
        fields() {

            const cidadao = [
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'dataNascimento', label: 'Data de nascimento', sortable: true },
                { key: 'nomeMae', label: 'Nome da mãe', sortable: true },
                { key: 'telefonePrincipal.numero', label: 'Telefone', sortable: true },
                { key: 'cns', label: 'CNS', sortable: true },
                { key: 'cpfNaoPertenceAoCidadao', label: 'CPF principal', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min' },
            ]

            const usuario = cidadao.map(f => ({ ...f, key: `cidadao.${f.key}` }))
            const paciente = cidadao.map(f => ({ ...f, key: `cidadao.${f.key}` }))

            return { cidadao, usuario, paciente }
        }
    },
    filters: {
        formatDate: formats.formatDate,
        formatPhoneOrCellPhone: formats.formatPhoneOrCellPhone,
    },
    props: {
        cidadaos: { type: Array, required: true },
        pacientes: { type: Array, required: true },
        usuarios: { type: Array, required: true },
        hideCidadaos: { type: Boolean, default: false },
        showUsuarios: { type: Boolean, default: false },
        showPacientes: { type: Boolean, default: false },
    },
}
</script>